import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { About } from './components/About';
import { Gallery } from './components/Gallery';
import { ScheduleLocation } from './components/ScheduleLocation';
import { PromoBanner } from './components/PromoBanner';
import { BookingCTA } from './components/BookingCTA';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
function App() {
  return <div className="min-h-screen bg-brand-bg selection:bg-brand-pink/30" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Services data-id="element-4" />
        <About data-id="element-5" />
        <Gallery data-id="element-6" />
        <ScheduleLocation data-id="element-7" />
        <PromoBanner data-id="element-8" />
        <BookingCTA data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
      <FloatingWhatsApp data-id="element-11" />
    </div>;
}
export { App };